<template>
  <div class="sa-rep-table-wrap">
    <table class="sa-rep-table">
      <thead>
        <tr>
          <th scope="col" class="is-id">
            <button type="button" class="sa-rep-table__sort" @click="$emit('sort', 'id')">
              ID <span aria-hidden="true">{{ sortMark('id') }}</span>
            </button>
          </th>
          <th scope="col" class="is-company">
            <button type="button" class="sa-rep-table__sort" @click="$emit('sort', 'name')">
              Empresa <span aria-hidden="true">{{ sortMark('name') }}</span>
            </button>
          </th>
          <th scope="col">Sistema</th>
          <th scope="col">Tipo</th>
          <th scope="col" class="is-date">
            <button type="button" class="sa-rep-table__sort" @click="$emit('sort', 'period')">
              Período <span aria-hidden="true">{{ sortMark('period') }}</span>
            </button>
          </th>
          <th scope="col" class="is-num">
            <button type="button" class="sa-rep-table__sort" @click="$emit('sort', 'revenue')">
              Receita <span aria-hidden="true">{{ sortMark('revenue') }}</span>
            </button>
          </th>
          <th scope="col" class="is-num">
            <button type="button" class="sa-rep-table__sort" @click="$emit('sort', 'fees')">
              Taxas <span aria-hidden="true">{{ sortMark('fees') }}</span>
            </button>
          </th>
          <th scope="col" class="is-num">
            <button type="button" class="sa-rep-table__sort" @click="$emit('sort', 'net')">
              Líquido <span aria-hidden="true">{{ sortMark('net') }}</span>
            </button>
          </th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="row in rows" :key="'fin-' + row.id + '-' + row.period">
          <td class="is-id">{{ row.id }}</td>
          <td class="is-company"><span class="sa-rep-table__name">{{ row.name }}</span></td>
          <td><SystemBadge :type-system="row.typeSystem" /></td>
          <td><CompanyTypeBadge :row="row" /></td>
          <td class="is-date">{{ formatMonthYear(row.period) }}</td>
          <td class="is-num">{{ formatCurrencyBRL(row.revenue) }}</td>
          <td class="is-num is-muted">{{ formatCurrencyBRL(row.fees) }}</td>
          <td class="is-num is-emphasis">{{ formatCurrencyBRL(row.net) }}</td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
import SystemBadge from './SystemBadge.vue';
import CompanyTypeBadge from './CompanyTypeBadge.vue';
import { formatCurrencyBRL, formatMonthYear } from '@/utils/superAdmin/formatters';

export default {
  name: 'FinancialReportTable',
  components: { SystemBadge, CompanyTypeBadge },
  props: {
    rows: { type: Array, default: () => [] },
    sortKey: { type: String, default: 'net' },
    sortDir: { type: String, default: 'desc' },
  },
  emits: ['sort'],
  methods: {
    formatCurrencyBRL,
    formatMonthYear,
    sortMark(key) {
      if (this.sortKey !== key) return '↕';
      return this.sortDir === 'asc' ? '↑' : '↓';
    },
  },
};
</script>

<style src="./report-table.css"></style>
